export default __webpack_public_path__ + "static/RobotoMono-Bold-a6439c84606bc4b6194757de13e66af9.ttf";